/**
 * FireCMS (markdown-it) salva spesso caratteri speciali con backslash (es. `\-`, `\*`).
 * Rimuove gli escape comuni senza interpretare tutto il markdown.
 */
export function unescapeMarkdown(text) {
  if (!text || typeof text !== 'string') return ''
  return (
    text
      .replace(/\\([\\`*_\[\]()#+\-.!|>~])/g, '$1')
      .replace(/\\\r?\n/g, '\n')
  )
}

/** Testo piano per meta / JSON-LD (niente markup). */
export function plainTextFromMarkdown(text, maxLength) {
  const plain = unescapeMarkdown(text)
    .replace(/!\[([^\]]*)\]\([^)]+\)/g, '$1')
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    .replace(/\*\*|__|\*|_|`/g, '')
    .replace(/^#{1,6}\s+/gm, '')
    .replace(/^[-*+]\s+/gm, '')
    .replace(/^\d+\.\s+/gm, '')
    .replace(/\n+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()

  if (maxLength == null || plain.length <= maxLength) return plain
  return `${plain.slice(0, maxLength - 1).trim()}…`
}
